var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoRi({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.58193 18.7611L11.4195 24.5255C11.6049 24.804 11.9173 24.9714 12.2519 24.9714H14.7871C15.59 24.9714 16.0655 24.0729 15.614 23.409L11.9626 18.0401C14.4145 17.1259 16.0969 15.1581 16.0969 12.0251V11.9694C16.0969 10.139 15.5193 8.61529 14.4429 7.53379C13.1764 6.25709 11.2739 5.56396 8.81999 5.56396H1C0.447715 5.56396 0 6.01168 0 6.56396V23.9714C0 24.5236 0.447715 24.9714 1 24.9714H3.2454C3.79768 24.9714 4.2454 24.5236 4.2454 23.9714V18.7611H7.58193ZM8.46253 9.41796C10.5287 9.41796 11.7971 10.36 11.7971 12.1904V12.2462C11.7971 13.8814 10.6135 14.9908 8.54529 14.9908H4.2454V9.41796H8.46253Z",
    fill: "#0C6DC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6627 11.1111C23.6627 10.5588 23.215 10.1111 22.6627 10.1111H20.4739C19.9216 10.1111 19.4739 10.5588 19.4739 11.1111V23.9714C19.4739 24.5236 19.9216 24.9714 20.4739 24.9714H22.6627C23.215 24.9714 23.6627 24.5236 23.6627 23.9714V11.1111Z",
    fill: "#0C6DC7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 5",
    filter: "url(#filter0_d_44_1708)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 5.5C24 6.88071 22.8807 8 21.5 8C20.1193 8 19 6.88071 19 5.5C19 4.11929 20.1193 3 21.5 3C22.8807 3 24 4.11929 24 5.5Z",
    fill: "#75C322"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_44_1708",
    x: 15,
    y: 0,
    width: 13,
    height: 13,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.505882 0 0 0 0 0.843137 0 0 0 0 0.14902 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_44_1708"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_44_1708",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRi);
export default __webpack_public_path__ + "static/media/logo-ri.3f6188f5d936766b47a4249c822daffc.svg";
export { ForwardRef as ReactComponent };